import React, { useState, useEffect, useRef } from 'react';

import { transRem2Px } from '@utils/common';
import { DragHandle } from './draggableLeafContainer';

const ExpandedDot = ({ delay }) => {
  // const style = { animationDelay: delay };
  const style = {};
  return (
    <div className="border-expanded-dot" style={style}>
      <div style={style}>
        <div style={style} />
      </div>
    </div>
  );
};

const Border = ({ quantity = 0, order, isShowDragHandle, handleDelete }) => {
  const [n, setN] = useState(quantity);
  const borderDomRef = useRef();

  const changeQuantity = () => {
    if (Number.isInteger(quantity) && quantity) {
      return;
    }

    const height = borderDomRef.current?.offsetHeight + transRem2Px(2.5) || 0,
      baseHeight = transRem2Px(0.875);

    const newQuantity = Math.ceil(height / baseHeight);
    if (n !== newQuantity) {
      setN(newQuantity);
    }
  };

  const totalTime = order !== undefined ? 1 : 3,
    delay = Math.max(0, (order || 0) - 2);

  useEffect(() => {
    let observer;

    if (!quantity) {
      observer = new ResizeObserver(changeQuantity);
      observer.observe(borderDomRef.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    };
  }, []);

  // console.log('????', n);
  return (
    <div className="border" ref={borderDomRef}>
      {Array.from(Array(n)).map((i, index) => (
        <div
          key={index}
          style={{
            animationDelay: `${(totalTime / n) * index + delay}s`,
          }}
        >
          {(() => {
            if (quantity && index === quantity - 1) {
              if (isShowDragHandle) {
                return (
                  <>
                    <DragHandle />
                    <div className="node-delete-btn" onClick={handleDelete}>
                      <span className="appkiticon icon-delete-fill a-font-12" />
                    </div>
                  </>
                );
              }

              return (
                Boolean(quantity && index === quantity - 1) && (
                  <ExpandedDot delay={`${quantity}s`} />
                )
              );
            }
          })()}
        </div>
      ))}
    </div>
  );
};

export default Border;
